












































































import { Component, Vue } from "vue-property-decorator";
import { ACTION_FETCH_USERS } from "@/store/actions-types";
import { GET_USERS } from "@/store/getters-types";
import { UserModelI } from "@/models/admin/UserModel";
import CreateUserBtnModal from "@/components/user-management/CreateUserBtn.vue";
import DeleteUserBtn from "@/components/user-management/DeleteUserBtn.vue";
import ChangePasswordBtn from "@/components/user-management/ChangePasswordBtn.vue";
import RoleBadge from "@/components/user-management/RoleBadge.vue";
import ChangeRoleBtn from "@/components/user-management/ChangeRoleBtn.vue";

@Component({
  components: {
    ChangeRoleBtn,
    RoleBadge,
    CreateUserBtnModal,
    DeleteUserBtn,
    ChangePasswordBtn,
  },
})
/**
 * Lists all proposed cpt's for moderation
 */
export default class UserManagement extends Vue {
  /**
   * indicate loading state
   */
  public isLoading = false;

  /**
   * table fields
   */
  public fields = [
    { key: "name", label: this.$t("views.admin.userManagement.name") },
    { key: "role", label: this.$t("views.admin.userManagement.role") },
    {
      key: "updated_at",
      label: this.$t("views.admin.userManagement.updatedAt"),
    },
    {
      key: "created_at",
      label: this.$t("views.admin.userManagement.createdAt"),
    },
    { key: "actions", label: this.$t("views.admin.userManagement.actions") },
  ];
  /**
   * load all registered users
   */
  async mounted(): Promise<void> {
    await this.fetchUsers();
  }

  /**
   * get users from store
   */
  get users(): UserModelI[] {
    let users = this.$store.getters[GET_USERS];
    if (Object.keys(users).length === 0) {
      return [];
    }
    return Object.keys(users).map((key: string) => {
      return users[key];
    });
  }

  /**
   * get array of usernames
   */
  get usernames(): string[] {
    return this.users.map((user) => {
      return user.name;
    });
  }

  /**
   * the last account cannot be deleted
   */
  get userDeletionActive(): boolean {
    return this.users.length > 1;
  }

  /**
   * reload user list
   */
  async fetchUsers(): Promise<void> {
    this.isLoading = true;
    await this.$store.dispatch(ACTION_FETCH_USERS);
    this.isLoading = false;
  }
}
